import React from 'react';

import { useLanguage } from '../i18n';
import CitySkyline from '../assets/ronda/city-skyline.webp';

const City = () => {
  const { city } = useLanguage().t;

  return (
    <section id='city' className='pb-20 lg:pb-28'>
      <div className='container'>
        <div className='grid gap-4 rounded-panel bg-ronda-soft p-3 sm:p-4 lg:grid-cols-[1fr_1.05fr] lg:items-stretch lg:gap-6'>
          <figure className='overflow-hidden rounded-[30px]'>
            <img
              src={CitySkyline}
              alt={city.imageAlt}
              loading='lazy'
              className='aspect-[4/5] h-full w-full object-cover lg:aspect-auto'
            />
          </figure>

          <div className='flex flex-col justify-center px-4 pb-6 pt-8 sm:px-8 lg:py-10 lg:pl-6 lg:pr-12'>
            <p className='eyebrow'>{city.eyebrow}</p>
            <h2 className='title mt-4 max-w-[420px]'>{city.title}</h2>
            <p className='lead mt-5 max-w-[460px]'>{city.text}</p>

            <ul className='mt-10 grid gap-3 sm:grid-cols-2'>
              {city.vehicles.map((vehicle) => (
                <li key={vehicle.color} className='rounded-[22px] bg-paper p-5'>
                  <p className='flex items-center gap-2 font-semibold'>
                    <span
                      className={`h-2.5 w-2.5 rounded-full ${vehicle.color}`}
                      aria-hidden='true'
                    />
                    {vehicle.name}
                  </p>
                  <p className='mt-2 text-[15px] leading-relaxed text-muted'>
                    {vehicle.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default City;
